export default "__VITE_ASSET__731f10cf__"